import { styled, Typography } from '@mui/material';

const StyledOverviewProfileSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(26),
  marginBottom: theme.spacing(1),
  fontWeight: 500
}));

export default StyledOverviewProfileSubtitle;
